import React, { useState } from 'react'
import { Card, makeStyles, Tooltip, Typography } from '@material-ui/core'
import classnames from 'classnames'
import PaymentIcon from '@material-ui/icons/Payment'
import { useTranslate } from 'react-admin'
import subscriptionNoticeStyles from './subscriptionNotice.styles'
import orgIsInSubscriptionState from '../../utils/helpers/orgIsInSubscriptionState'
import orgIsPayLocked from '../../utils/helpers/orgIsPayLocked'
import SUBSCRIPTION_STATES from '../../utils/constants/subscriptionStates'
import useHistoryPush from '../../hooks/useHistoryPush'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import localStorageIds from '../../utils/constants/localStorageIds'
import USER_PERMISSIONS from '../../utils/constants/userPermissions'
import hasPermission from '../../utils/helpers/hasPermission'

const SubscriptionNotice = () => {
  const translate = useTranslate()
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)
  const { redirect } = useHistoryPush()
  const useStyles = makeStyles(subscriptionNoticeStyles)
  const classes = useStyles()
  const localStorageValue = useGetLocalStorage()
  const {
    [localStorageIds.SELECTED_ORG_SUB_STATUS]: selectedOrgSubscriptionStatus,
  } = localStorageValue || {}
  const successStylesShown = !orgIsPayLocked()
  const userIsOwner = hasPermission(USER_PERMISSIONS.DO_BILLING)

  const openTooltip = () => setIsTooltipVisible(true)
  const closeTooltip = () => setIsTooltipVisible(false)

  const handleNoticeClick = () => {
    if (!userIsOwner) return

    redirect('/subscription')
  }

  const SUBSCRIPTION_TEXT = {
    [SUBSCRIPTION_STATES.INACTIVE]: 'Subscribe',
    // A pending org's price is already set; Subscribe on the overview tab takes the first
    // payment (Viva's checkout collects the card), so it stays accurate with or without a card.
    [SUBSCRIPTION_STATES.PENDING]: translate('ra.buttons.completeSubscription'),
  }

  // No cached status (org-less user, or the status query hasn't returned yet):
  // don't flash an empty chip.
  if (!selectedOrgSubscriptionStatus) return null

  if (orgIsInSubscriptionState([SUBSCRIPTION_STATES.ACTIVE, SUBSCRIPTION_STATES.GRACE])) return null

  return (
    <Card
      className={classnames(classes.card, {
        [classes.successCard]: successStylesShown,
        [classes.failureCard]: !successStylesShown,
      })}
      elevation={0}
      onClick={handleNoticeClick}
      style={{ cursor: userIsOwner ? 'pointer' : 'default' }}
    >
      <Tooltip
        open={isTooltipVisible}
        onClose={closeTooltip}
        onOpen={openTooltip}
        title={`${selectedOrgSubscriptionStatus}`}
        classes={{ tooltip: classes.tooltip }}
      >
        <PaymentIcon
          className={successStylesShown ? classes.successCloudIcon : classes.failureCloudIcon}
          onClick={openTooltip}
        />
      </Tooltip>
      <div className={classes.trialPeriodText}>
        <Typography
          className={
            successStylesShown ? classes.successTypographyBold : classes.failureTypographyBold
          }
        >
          {SUBSCRIPTION_TEXT?.[selectedOrgSubscriptionStatus]}
        </Typography>
      </div>
    </Card>
  )
}

export default SubscriptionNotice
